export default "__VITE_ASSET__DBqsCs$v__"